export class Addons {
  manageGrc = false;
  manageGrcAccessGovernance = false;
  manageGrcAppUsage = false;
  manageRoles = false;
  refreshActiveDirectory = false;
  manageIpRestriction = false;
  manageUpdateServer = false;
  exportPreloadPasswords = false;
  managePermissionCreatePasswordForPreloadUrl = false;
  managePermissionCopyPasswordPreloadPassword = false;
  managePermissionActivateMobile = false;
  manageRequireExtensionCode = false;
  autoUpdatePreloadPassword = false;
  managePreloadSystems = false;
  creditCards = false;
  contingencyBackup = false;
  applicationAccess = false;
  deviceRestriction = false;
  manageShowCardNumber = false;
  disableInputFieldsByExtension = false;
  managePWAutomaticUpdate = false;
  enableExternalApi = false
  multiFactorAuthentificationKey = false;
  multiFactorAuthentificationKeyAccessKit = false;
  enableExternalApiGrc = false;
  enableExternalApiAccessKit = false;
  manageSshPassword = false;
  manageCreateCustomPassword = false;
  manageLoginWithoutTFA = false;
  disableAutoFillExtension = false;
  manageRememberSecurityAnswers = false;
  manageReportsUserInactivity = false;
  manageForceTwoFactor = false;
  entraScimProvisioning = false;
  credentialProvider = false;

  constructor(input: any) {
    this.manageGrc = input.manageGrc;
    this.manageGrcAccessGovernance = input.manageGrcAccessGovernance ?? false;
    this.manageGrcAppUsage = input.manageGrcAppUsage ?? false;
    this.manageRoles = input.manageRoles;
    this.refreshActiveDirectory = input.refreshActiveDirectory;
    this.manageIpRestriction = input.manageIpRestriction;
    this.manageUpdateServer = input.manageUpdateServer;
    this.exportPreloadPasswords = input.exportPreloadPasswords;
    this.managePermissionCreatePasswordForPreloadUrl = input.managePermissionCreatePasswordForPreloadUrl;
    this.managePermissionCopyPasswordPreloadPassword = input.managePermissionCopyPasswordPreloadPassword;
    this.managePermissionActivateMobile = input.managePermissionActivateMobile;
    this.manageRequireExtensionCode = input.manageRequireExtensionCode;
    this.autoUpdatePreloadPassword = input.autoUpdatePreloadPassword;
    this.managePreloadSystems = input.managePreloadSystems;
    this.creditCards = input.creditCards;
    this.contingencyBackup = input.contingencyBackup;
    this.applicationAccess = input.applicationAccess;
    this.deviceRestriction = input.deviceRestriction;
    this.manageShowCardNumber = input.manageShowCardNumber;
    this.disableInputFieldsByExtension = input.disableInputFieldsByExtension;
    this.managePWAutomaticUpdate = input.managePWAutomaticUpdate;
    this.enableExternalApi = input.enableExternalApi;
    this.multiFactorAuthentificationKey = input.multiFactorAuthentificationKey;
    this.multiFactorAuthentificationKeyAccessKit = input.multiFactorAuthentificationKeyAccessKit;
    this.manageSshPassword = input.manageSshPassword;
    this.enableExternalApiGrc = input.enableExternalApiGrc;
    this.enableExternalApiAccessKit = input.enableExternalApiAccessKit;
    this.manageCreateCustomPassword = input.manageCreateCustomPassword;
    this.manageLoginWithoutTFA = input.manageLoginWithoutTFA;
    this.disableAutoFillExtension = input.disableAutoFillExtension;
    this.manageRememberSecurityAnswers = input.manageRememberSecurityAnswers;
    this.manageReportsUserInactivity = input.manageReportsUserInactivity;
    this.manageForceTwoFactor = input.manageForceTwoFactor
    this.entraScimProvisioning = input.entraScimProvisioning
    this.credentialProvider = true
  }
}
export class Company {
  id = 0;
  endsAt = '';
  seatsUsed = 0;
  seats = 0;
  prefix = '';
  nextUpdateAt = null;
  addons: Addons = new Addons({});
  constructor(input: any) {
    this.id = input.id;
    this.endsAt = input.endsAt;
    this.seats = input.seats;
    this.seatsUsed = input.seatsUsed;
    this.prefix = input.prefix;
    this.nextUpdateAt = input.nextUpdateAt;
    this.addons = new Addons(input.addons ? input.addons : {});
  }
  isExpired(): boolean {
    return new Date() > new Date(this.endsAt);
  }
}
